import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/header/header";
import Footer from "../components/footer/footer";
import ElevationScroll from "../utilities/elevationScroll";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";

function DefaultLayout() {
  return (
    <>
      <ElevationScroll>
        <Header drawerWidth={0} />
      </ElevationScroll>
      <Toolbar />
      <Box component={"main"}>
        <Outlet />
      </Box>
      <Footer />
    </>
  );
}

export default DefaultLayout;
